import { validateArguments } from '../../SignatureValidation';
export var RegexpMatchFn;
(function (RegexpMatchFn) {
    RegexpMatchFn.Name = `REGEXP_MATCH`;
    RegexpMatchFn.Stage = "SCALAR";
    RegexpMatchFn.Signature = `REGEXP_MATCH(<string>, <pattern>, [<flag>])`;
    function make(callName, args, type, role) {
        return {
            name: RegexpMatchFn.Name,
            stage: RegexpMatchFn.Stage,
            data: { type, role },
            value: (...argVals) => {
                throw new Error(`Scalar REGEXP_MATCH not yet implemented`);
            },
        };
    }
    RegexpMatchFn.make = make;
    function validate(callNode, callName, args) {
        const sig = {
            meta: { name: RegexpMatchFn.Name, signature: RegexpMatchFn.Signature, location: callNode.location },
            arguments: args.length === 2
                ? ["STRING", "STRING"]
                : ["STRING", "STRING", "BOOLEAN"],
        };
        return validateArguments(sig, args);
    }
    RegexpMatchFn.validate = validate;
})(RegexpMatchFn || (RegexpMatchFn = {}));
